/* Qualified audio previews. No UI or playback mutations. */
(() => {
 if(window.ChiaisPreviewAnalytics)return;
 window.ChiaisPreviewAnalytics=true;
 const config=document.querySelector('[data-bgm-analytics-config]');
 if(!config)return;
 const states=new WeakMap(), totals=new Map(), sent=new Set();
 function info(audio){
  const card=audio.closest('bgm-card-preview');
  if(card)return {track_id:card.dataset.trackId,track_title:card.dataset.title,player_surface:'card'};
  const lib=audio.closest('bgm-library'),row=lib?.current;
  if(row)return {track_id:row.dataset.trackId,track_title:row.dataset.title,player_surface:'library'};
  if(audio.closest('.ccm')&&config.dataset.productId)return {track_id:config.dataset.productId,track_title:config.dataset.productTitle,player_surface:'product'};
 }
 function handle(event){
  const a=event.target;if(a.tagName!=='AUDIO')return;
  const i=info(a);if(!i?.track_id)return;
  const now=performance.now(),t=a.currentTime||0,src=a.currentSrc||a.src;
  let s=states.get(a);
  if(!s||s.id!==i.track_id||s.src!==src)s={id:i.track_id,src,t,now,playing:false};
  const delta=t-s.t,elapsed=(now-s.now)/1000;
  if(event.type==='timeupdate'&&s.playing&&!a.paused&&!a.seeking&&delta>0&&elapsed>0&&delta<=elapsed*Math.max(1,a.playbackRate)+.25){
   totals.set(i.track_id,(totals.get(i.track_id)||0)+Math.min(delta,elapsed));
  }
  s.t=t;s.now=now;
  if(event.type==='playing')s.playing=true;
  if(['seeking','waiting','pause','ended','emptied','error'].includes(event.type))s.playing=false;
  states.set(a,s);
  if((totals.get(i.track_id)||0)>=10&&!sent.has(i.track_id)&&window.Shopify?.analytics?.publish){
   const accepted=window.Shopify.analytics.publish('chiais_preview_qualified',{...i,preview_seconds:10,preview_environment:config.dataset.environment});
   if(accepted!==false)sent.add(i.track_id);
  }
 }
 ['playing','timeupdate','seeking','seeked','waiting','pause','ended','emptied','error'].forEach(type=>document.addEventListener(type,handle,true));
})();